<!--
 * @Description:
 * @Author: Rfan
 * @Date: 2020-12-10 15:52:06
 * @LastEditTime: 2023-10-10 11:03:38
-->

<template>
  <div class="pages service">
    <hsj-pro-term v-if="app === 'hsjpro'"/>
    <hsj-term v-else/>
  </div>
</template>

<script>
import { testApp } from '@/utils';
import HsjTerm from './hsj/Term';
import HsjProTerm from './hsjpro/Term';
export default {
  name: "Term",
  data() {
    return {
      app: null
    }
  },
  components: {HsjTerm, HsjProTerm},
  computed: {},
  created() {
    const app = this.$route.params?.app;
    this.app = app;
  },
  methods: {
    testApp,
    isHsjPro() {
      return this.testApp('hsjpro');
    }
  }
};
</script>

<style lang="scss">
.service {
  .container {
    h1 {
      font-size: 24px;
    }

    li {
      a {
        color: #1989fa;
        text-decoration: none;
      }
    }

    ul {
      margin-top: 1em;
      padding-left: 0;

      li {
        &::before {
          content: "";
        }
      }
    }
  }
}
</style>
